export function getLogoURL(logoUrl){
  if (logoUrl === undefined || logoUrl === null || logoUrl === '') {
    return 'https://res.cloudinary.com/dghqjv5az/image/upload/v1669488763/mix/logossala/logowhite_dzsb2i.png'
  }

  return 'https://res.cloudinary.com/dghqjv5az/image/upload/linkedwgt/' + logoUrl
}
